<div class="acc-order-details">
  <div class="row flex-column account-overview-header">
    <h3 class="add-to-cart-title">Add to your cart</h3>
    <h6 class="heading6-vsh">QUICK ADD</h6>
    <p class="body-copy">Search for items by name, number or keyword</p>

    <div class="row qckOrdrBtnblk">
      <div class="input-group header-SearchBar " role="search">
        <app-quick-order></app-quick-order>
      </div>
    </div>
  </div>
</div>
<div class="ad-upload-order">
  <h6 class="heading6-vsh">UPLOAD ORDER</h6>
  <p class="body-copy">Add items to your cart via the Excel order template</p>
  <div class="drag-drop drag_drop_file" id="drag_drop_file" fileDragDrop (filesChangeEmiter)="onFileChange($event)">
    <div class="drag_drop_file_inside">
      <p class="body-copy-bold">Drag and drop file here to upload</p>
      <span class="body-copy">-or-</span>
    </div>

    <div class="btn-secondary">
      <label for="img" class="text browse-ticket">Select a file</label>
      <input type="file" name="uploadfile" (change)="orderUploadFile($event)" (click)="uploadClick($event)" id="img"
        style="display:none;" />
    </div>
  </div>
  <a class="text-link sanofi-download-icon" target="_blank" (click)="downloadXls()">
    <img src="/../../../assets/icons/{{baseSiteId}}/download.png" alt="order_template">
    Download the order template</a>
</div>